module.exports = __webpack_public_path__ + "static/media/1985_maleRate_femaleRate.4cd2fb11.png";